import { createContext } from "react";
import { Size } from "./hooks/useWindowSize";

export type AppContextProps = {
  size: Size;
  openBookingEngine: (startDate?: Date, endDate?: Date) => any,
}

const AppContext = createContext<AppContextProps>({
  size: {
    width: undefined,
    height: undefined,
  },
  openBookingEngine: () => {},
});

export default AppContext;